var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-data-table',{attrs:{"items":_vm.Errors,"headers":_vm.headers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }